export const Login = async (username: string, password: string, app_id?: string, redirect_url?: string) => {
    const data = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/login`, {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({ app_id, email: username, password, redirect_url }),
        headers: { 'Content-Type': 'application/json' }
    })
    const result = await data.json()
    console.log(result, 'wew')
    if (data.status === 200) {
        return result
    } else {
        throw new Error(result.detail)
    }
}

export const RecoverRequest = async (email: string, app_id?: string) => {
    const data = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/recover/request`, {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({ email, app_id }),
        headers: { 'Content-Type': 'application/json' }
    })
    const result = await data.json()
    if (data.status === 200) {
        return result
    } else {
        throw new Error(result.detail || result.message || 'Failed to send recovery code')
    }
}

export const RecoverVerify = async (code: string, access_token: string, verification_code: string) => {
    const data = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/recover/verify`, {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({ code, access_token, verification_code }),
        headers: { 'Content-Type': 'application/json' }
    })
    const result = await data.json()
    if (data.status === 200) {
        return result
    } else {
        throw new Error(result.detail || result.message || 'Invalid verification code')
    }
}